// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"306":"f18bb20b","607":"ccf00d36","762":"739284ac","770":"f0b52ead","787":"b8cb6d2d","841":"083c4630","968":"a906d46b"}[chunkId] + ".chunk.js";
};